import { DialogV2 } from '@yuno/design-system-web'

export const DialogComponent = (props) => {
  const { openDialog, handleOpenDialog, children } = props

  return (
    <DialogV2 {...props} open={openDialog} closeIcon={handleOpenDialog}>
      {children}
    </DialogV2>
  )
}
